import { imageUriToFormData } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { dataURItoFile } from 'chat/shared/util'
import { Platform } from 'react-native'
import keys from './shared/keys'

type Variables = {
  photoUrl: string
  mimeType: string
}

export function useUpdateUserPhoto() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationKey: keys.account(),
    mutationFn: async ({ photoUrl: avatarUrl, mimeType }: Variables) =>
      server.post(
        '/v2/users/me/profile/photo',
        await getUpdateUserPhotoForm(avatarUrl, mimeType),
        'user',
        'multipart/form-data'
      ),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: keys.account() })
    },
  })
}

async function getUpdateUserPhotoForm(
  photoUrl: string,
  mimeType: string
): Promise<FormData> {
  const form = new FormData()
  if (Platform.OS === 'web') {
    const imageType = mimeType.split('/')[1]
    const name = `profile_photo.${imageType}`
    if (photoUrl.startsWith('blob:')) {
      const response = await fetch(photoUrl)
      const blob = await response.blob()
      const file = new File([blob], name, { type: mimeType })
      form.append('file', file)
    } else {
      form.append('file', dataURItoFile(photoUrl, mimeType, name))
    }
  } else {
    return imageUriToFormData(photoUrl)
  }
  return form
}
